import {CARD_TYPES} from 'common/requestDetails/constants.js';
import Simple from './Simple';
import ContainerItem from './ContainerItem';
import SimpleHiring from './SimpleHiring';

export {Simple};

export const Cards = {
  [CARD_TYPES.SIMPLE]: Simple,
  [CARD_TYPES.SIMPLE_HIRING]: SimpleHiring,
  [CARD_TYPES.STAFFING_BUNDLED]: SimpleHiring,
  ContainerItem: ContainerItem,
};
export default Cards;
